import url from "/vercel/path0/src/pages/Pickups/SchedulePickup/images/world.svg?url";
export default url;
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorld = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1181,
	height: 944,
	viewBox: "0 0 1181 600",
	role: "img",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "Globe with delivery routes, a delivery truck and stacks of laptops on boxes"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "gl-mask",
				children: /* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M122.9 863.2c-50-115.5-54.6-237.5-22.3-349.3 33.1-114.4 105.5-217.2 203.3-285.3 99.4-69.2 218.6-99.3 338.6-86.7 119.7 12.6 231.3 66.9 314.2 153.9s132.9 200.7 142 320.1c6.4 84.3-8 168.6-42 246-.3.9-.4 1-.5 1.3z"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "st-mask",
				children: /* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					fillRule: "evenodd",
					d: "m836.3 371.5-64.8-37.9.2-7.3h-2l-6.8 5.3-3.3.1-46-25.9-19.4-11.6.6-4.8 47-27.3 1.7-.5 5.3 2.5 3.5-3.5-31.7-18.7-2.5-2.1v-28.6l-1-2.7-.5-9.7 2.8-2.9-.9-6.4v-22.3l-1.6-12.9-.8-2.3 3.9-2.7-.8-1.9 1.3-1.4 3.1-.4-2.7-3.2.6-2.5 6.1 2.8.4-1.5-12.1-8.6.4-2.9 5.7-4.2-2.7-3-.3-2.4 3.9-2.8L787 79.9l4.1 1.2 47.8 28.7-.2 3.3-5 4.5 1.8-.6 6.4 5.2v3.4l-5 5.3 2.8-.7 1.3 1.3v2l-3.1 3.1 3 .7.4 3.8 14.5-9.2 1.8-.1 5.2-3.4 13.9-7.5 2.7.1 39.5 22.6 8.5 4.7 16.7 9.9 2.8 2 .1 3.3-4.9 4.2 2.8-.3 2.1 2.1-.2 2.2-4.5 3.9 3.7.6.2 2.9-3.2 3.5 4.9.4 1.3 3.3-1.1 2.4-5.4 3.6 1.5 4.8-1.5 3.5 2.3.4-.1 3 3.9 2.3.1 9.2-1.7 8-.2 26.4-1.4 1.7 3.3 1.7-.1 9.5-1 1.6.1 21.8 5.5 6.7-6.5 2.8-52.7 31.3-4.1-1.4-5.9 6 1.4 4.1-1.9 2.7 2.5 4.3-1 1.4-39.8 23zM826.9 259l-1.9-2.5.2-11.5 4-3-1.7-3-36.2 21.6 1.3.9 34.2 5z"
				})
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "gl-rim",
				cx: 892,
				cy: 627,
				r: 820,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .842,
						stopOpacity: 0
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .842,
						stopOpacity: .062
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .873,
						stopOpacity: .05
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .903,
						stopOpacity: .032
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopOpacity: .019
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "tk-gu",
				x1: 0,
				x2: 0,
				y1: 0,
				y2: 1,
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#444b4b"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#36464c"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "hb-c",
				children: /* @__PURE__ */ _jsx("polygon", { points: "1000,740 1095,740 1067,840 1000,840" })
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "gl-hl",
				d: "M995.9 559.3c-27.5 22.6-102.5 31.3-230.1-15.1-12.1-4.4-46.4-16-104.2-50.3-20.8-12.3-100.3-64.7-130.4-124-1.5-2.9-58.5-98.1 11.9-161.7 72.6-65.5 250.1-24.8 370.8 80.5 23.7 20.8 43.8 33.3 79.5 98.9 25.5 47 44.6 137.1 2.5 171.7"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "hb-h",
				fill: "#fff4f2",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						r: 25.7,
						fillOpacity: .3
					}),
					/* @__PURE__ */ _jsx("circle", {
						r: 16.9,
						fillOpacity: .32
					}),
					/* @__PURE__ */ _jsx("circle", {
						r: 15.9,
						fill: "none",
						stroke: "#fff4f2",
						strokeOpacity: .1,
						strokeWidth: .6
					}),
					/* @__PURE__ */ _jsx("circle", {
						r: 9.7,
						fillOpacity: .07
					})
				]
			})
		] }),
		/* @__PURE__ */ _jsxs("g", {
			id: "gl-globe",
			mask: "url(#gl-mask)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "gl-ocean",
					width: 1040,
					height: 740,
					x: 70,
					y: 130,
					fill: "#088ac3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "gl-rim-sea",
					width: 300,
					height: 740,
					x: 70,
					y: 130,
					fill: "url(#gl-rim)",
					opacity: .587
				}),
				/* @__PURE__ */ _jsx("use", {
					id: "gl-hl-sea",
					fill: "#0085c3",
					href: "#gl-hl"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "gl-land",
					fill: "#71b19e",
					fillRule: "evenodd",
					d: "M3623 2716c-16-186-19 269 231-600 2-5-17 47 184-210 42-53 285-234 477-42 37 38-193 229-51 232l43-22c63 32 35 60 126-47 20-24 215-56 88 101-4 5-216 278-106 314 17 5 114 43 28 157-90 121 25 178 14 249-29 186-221 119-78 349 40 66-93 52-80 207 0 5-3 79-215 137-133 36-97 212-271 285-187 78-141 265-159 315-1 5-53 196-168 174-7-1-116 32-178-162-102-319-55-57-68-600-8-370 103-553 70-628-7-15 68-64 92-193 2-13 21-15 21-16m1998-560c51-49 118-14 172 32q6 2 12-4c-16-53-13-4-23-54 23-34 28-26 65-7 14-41 7-63 310-63 49 1 104 102-68 117-61 5-56 26-58 28 56 127 189 80 166 160-78 32-136-73-192-87-72 61 36 258-142 147-59-36 18-54-109-116-3-2-143-115-134-139zm935 6549c-29-203 95-138 73-416-1-9-73-416-113-415-4 0-139-121-107-169 2-3 12-144-166-104-67 15-82-164-155-164-94 0 9-44-224 55-74 31-83-37-212 86-22 21-154 52-346-206-82-109-190-58-111-391 16-69-70-285 94-477 8-10 239-164 165-260-4-5-32-72 164-247 25-23 22-54 195-41 66 4 116-121 276-121 90 0 305-123 343 70 9 40-146 137 243 227 51 12 153 113 161-75 0-4 38-106 176 3 125 100 212-44 431 63h14c13-17 8 53 34-267 7-78 15-39 2-81-69-20 16 30-176-4-107-19-48 77-179 7-5-3-62-96-97-260q-8-14-14-16c-3 0-209 38-73 161 1 1 15 57-46 93-17 10 15-10-16 28-34-11-5 31-54-132-9-30-81-19-122-180-36-145-149-33-203-207-16-52-143-30-45 99 125 165 191 130 213 205-41 69 10-26-32 43 17 41 54 49-22 96-2 1-15 72-80 56-17-4-23-39-24-40 37-41 31-11 78-39 12-147-113-94-245-322-2-3-53-82-184 29-58 49-136-64-145 90-3 60-125 33-158 249-22 138-183 155-267 119-5-3-139 48-165-260-1-13-6-120 124-144 69-13 306 31 175-251-25-54-89-55-120-90 68-85 110 18 149-95 64-8 57 51 215-167 41-56-19-131 143-185 4-1 81-40 10-206-29-67 102-160 99-10-2 135 16 162 292 186 5 0 190-3 160-196-8-55 19-22-7-108-8-26 37-16 38-16 16 36 7-12 2 52 2 1 13 32 90 15 51-83-105-82-71-186 16-48 165 4 213-58-18-139-294 26-312-81 0-5-23-26-33-248-1-32 146-102 61-247-2-3-88-69-131 112-27 118-200 186-35 463 71 120-36 183-17 239 1 3 24 126-127 88-61-16-49-261-210-165-2 1-139-5-132-25 8-25-152-70-24-303 9-17 10-40 189-452 40-93-46-310 163-314 38-1 59-177 341-134 57 9 53 78 115 105 27-14 29-90 447 173 51 32 185 183-58 153-197-25-70-30-143-21-2 4-48 30 153 180 76 57 127-141 227-175 43-14-8-101 12-181 167-81 68 163 213 105 4-2 170-181 166-185-28-35 242-205-5-568-76-111 151-462 397-108l4 13c-46 82-249-3-126 237 42 81 64-104 408-51 13 2 261-28 521-366 103 27 1457 1030 1908 2839 150 601 159 959 155 978-56 15-66-43-338 176-93 75-23 65-157 49-19-3-179 96-15 243 26 23-17 20 71 150 2 4 51 173-73 232-23 10-21 80-81 98-53-48 42-36-156-203l-19-27c-24 31-44 173-30 186 23 23-62-46 136 210 3 3 34 183 27 185l-8 11c-43 5-122-37-147-224-15-109-97-15-74-271 4-51-78-361-127-322-2 2-80 38-92-86-6-67-28-179-99-191-86 64 64-6-119 65-27 10 2 32-237 328-34 42 57 215-102 423-7 9-26 7-26 7-18-13 12 71-156-385-32-87-76-320-90-342-66 47-86 129-175-71-3-6-87-149-330-64-9 3-86 25-217-75-52-40-12 112-328-196l-12-3c-8 9-62 28 51 223 19 31 108 26 96 94l7 12c84 33 128-42 186-67 62 33 33 85 122 101 8 2 135 66-125 357-21 24 58-51-215 130-5 3-281 135-295 48-3-22-2 41-53-173-11-45-59-5-374-565 0-1-17-26-47-37-80 122 183 366 192 520 5 89 253 244 254 342 0 5 47 113 223 51 129-46 293-123-10 407-39 69-436 332-294 684 3 7 64 265-90 338-73 34-28 89-48 146-32 6-1091 7-1126-1M3495 2895c-38-25-18-22-55-77 2-2 21-53 121-43-30 58-56 60-66 120m-1220 367c7-53 21-27 41-76-48-37-94 0-130-64 56-126 182 48 291-92 50-64 234 1 177 174-141 42-293 126-379 58m-364-67c6-11 59-82 90-103 216 87 28 306-13 173-1-4-53-41-77-70m745 5512c-67-215 138-4-288-313-152-111-1-186-62-231-70-51 108-262 86-296-3-4 7-178-92-220-24-10-37 47-45 63-78 17-263-141-250-156 3-4-35-129-190-139-83-6-151-149-274-116-67 17-390-117-354-235 2-6 21-103-177-291-93-88-157-307-281-240l-13-2c-15-50-35-1214 548-2345l11-8c78 25 150 123 216-104 6-20 14-11 19-51-43-46-81-42-110-80 11-42 137-259 178-288 167 69 64 105 153 144 5 2 78 48-111 212q-4 6-3 14c55 48 177 23 198-94 7-43 76-48 121-200 15-48 26 18 167-306 2-6 120-92 130-75l11 8c30 98-204 255-132 345 9 11-2 30 19 73 35 11 124-11 38 133q-1 18 6 26c69 27 151-97 154-186 1-24 86-31 84-125-110-76-188 56-201-78 0-5 90-156 183-185 53-17-70 8 132-42 38-10 52-61 152 12 31 23 14-70 133 98 9 13 204 4 166 222-9 53 162 116 158 129-5 17 74 9-71 127-21 16 22 65-64 93-49-26-91-179-131-50-24 77 187 193 29 254-49 20 36 248-185 59-90-77-50-109-184-93-20 3-75-67 58-125 12-5 10-20 144-197 11-15 0-147-93-49q-7 3-13-1c-35-90 87-187-115-142-3 1-117 45-58 144 3 5 6 113-222 232-33 17 14 57-78 61-87 4 105 146-175 162-4 0-112 55-51 133 2 2 15 64-84 134-109 77-71 157-17 287 20 48 325 150 322 159 0 3-6-55 30 179 11 64 144 135 123-67-18-162 161-190 110-328-65-175 6-86 14-311 1-46 141-222 231-55 19 35 83 28 68 156 0 2 1 37 42 69 76-18 154-193 231 31 4 14-25 90 221 293 61 50 13 102 16 270 20 10 77 11 124 137 15 39-27 92-118 34-22-14-94 15-152 0-29-62 50-130 27-198-22-10 20-30-289 57-3 0-77 31-101 81 54 9-11-16 107 0l12 7c-2 11-56 134 57 199 39 23 99-91 112-84l13 3c32 85-85 130-113 181-2 3-110 65-160-19q-6-5-14-3c-72 37 67-19-117 69-22 11-21 183-133 195-6 0-196 119-120 324 30 80-199 187-193 311 1 19-51 64 25 121 20 16 62 164-37 145-79-16 1-262-291-231-58 6 1 95-167 50-102-27-348 251-122 530 32 39 206 61 207-80 0-44 204-121 119 65-9 20 14-43-21 137-21 110 272-79 224 196-21 121 89 220 158 152 34-35 95 21 135 30 68-56 9-101 185-185q28-4 34 3c11 56-26 56 9 96 53-59 16-125 170-40 59 33 186-28 191 2 3 22 103 41 217 170 2 2 86 89 94 80 3-3 135-4 198 97l112 124c-17 58-21 14-23 61 59 12 37-45 107-1 9 6 1-5 6 38 4-2 91-71 195 43 33 36 209-19 301 86 56 64 140-4 147 205 2 80-136 212-96 242l-2 70c-33 8-1563 6-1595 2m-627-5272c11 45 0 29-37 72 10 19 62 57-71 169-54 46-205-77-34-169 3-1 18-86 131-80zm1186 231c-22-9-93-92-70-169 150 5 106 147 70 169m1510-2 40 26c54-25 54-49 128-43 27 3 109-143 182 78 30 91-275 344-377 19 0-2-12-51 27-80m-2406 516c2 1 110 29 33 95-20 18-10-25-103 34-29 18-167 23-39-179 3-5 92-41 102 38q1 8 7 12m3266 647c-143-10-28 51-207 58l-12-8c-21-71 19 51-21-163-10-55 86-22 80-88l8-10c20 90 110-39 69-75-18-16 10 34 6-120 0-3 21-224 160-46 35 45-22 146 6 146 34 0 34 112 135 151 33 13-41-23 56 77 13 15 43 164-214 191-40 4-46-71-66-113m2630 670c38-68 138-63-66-181-2-2-88-68-18-145 26-30-33-222-171-31-41 56-26 219 27 228 5 1 112 141 95 226-10 49 132 214 198 62 14-32-43-111-65-159m-744-428c-129 52-64 122-111 174-62-27-70-206-187-102-4 5-103 259-43 308 57 47 99-7 215-9 57-1-44-39 247 16 50 10 179-96 20-154-17-6-101-43-92-172 2-41-48-60-49-61m-1146 520c-3 0-49 15-61-143-3-39 23-53 24-54 77 14 79 181 48 189zm-4240 163c83-33 25-83 94-128q5-6 3-13c-53-71-143-32-216-193-90 11-156 113-213 139q-7 7-5 10c57 20 149-55 164 96 5 48-64 114 14 145 53-44 22-213 146-133 26 16 0 42 13 77m3899-145c-8-39 17-79 71-41 0 2 4 58-71 41M2055 6962c-44-68 92-125 220-53 42 24-76-50 164 76 15 8 10 38 10 39-51 32-165 20-188-30-2-3-123-88-179-34q-20 7-27 2m423 174c20-39 10-2 54-46l-13-45c83-40 212-4 241 50-25 64-21-2-145 59-9 4-59-25-125-13zm7073 192q-5 6-9-14c3-49-56-24-6-143q4-5 12-6c33 17-4-22 55 77 21 34-43 63-38 84q-3 3-14 2m1193 478c-106-119-67-110-95-148-2-3-49-108 60-124 13-1-3-8 84-92 35-33 70-168 105-210 22 3 124 22 139 31 2 31-73 468-102 509-45 7-61-16-121-17-18 63-68 52-70 51m-197-11c28-14 26-13 38-50 61 68-19-53 70 77l26-7c7-42 2 5 2-53 2 0 28-14 63 98 1 4 19 151-98 196l-9 10c49 36 24-4 64 34-31 20-205 31-236-75-5-16-1 21-46-101-9-26-17 19-93-152-17-39-28-21-49-129-1-4-63-135-113-192-117-135-71-187 31-115 36 25 7 36 199 250 39 44 28 79 67 103 12 7 1 72 84 106m-2332 913c-19 2-207 6-243-3-23-305 86-110 195-346q30-51 38-49c17 9 55 2 51 175 0 4-49 80-37 218z",
					transform: "scale(.1)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "gl-rim-land",
					width: 300,
					height: 740,
					x: 70,
					y: 130,
					fill: "url(#gl-rim)",
					opacity: .413
				}),
				/* @__PURE__ */ _jsx("use", {
					id: "gl-highlight",
					fill: "#edfdfe",
					fillOpacity: .22,
					href: "#gl-hl"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "hb-halos",
			children: [
				/* @__PURE__ */ _jsx("use", {
					x: 827,
					y: 398.7,
					href: "#hb-h"
				}),
				/* @__PURE__ */ _jsx("use", {
					x: 557,
					y: 466.9,
					href: "#hb-h"
				}),
				/* @__PURE__ */ _jsx("use", {
					x: 268.3,
					y: 491.1,
					href: "#hb-h"
				}),
				/* @__PURE__ */ _jsx("use", {
					x: 948.9,
					y: 542.1,
					href: "#hb-h"
				}),
				/* @__PURE__ */ _jsx("use", {
					x: 775.3,
					y: 599.9,
					href: "#hb-h"
				}),
				/* @__PURE__ */ _jsx("use", {
					x: 137.2,
					y: 621.7,
					href: "#hb-h"
				}),
				/* @__PURE__ */ _jsx("use", {
					x: 596.4,
					y: 674.8,
					href: "#hb-h"
				}),
				/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#hb-c)",
					children: /* @__PURE__ */ _jsx("use", {
						x: 1058.8,
						y: 789.9,
						href: "#hb-h"
					})
				}),
				/* @__PURE__ */ _jsx("use", {
					x: 292.8,
					y: 805.2,
					href: "#hb-h"
				}),
				/* @__PURE__ */ _jsx("use", {
					x: 703,
					y: 804.4,
					href: "#hb-h"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "rt-arcs",
			fill: "none",
			stroke: "#fff",
			strokeDasharray: "16.4 13.35",
			strokeWidth: 3.5,
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "rt-5-2",
					strokeDashoffset: -2.2,
					d: "M137 622c-1-70 57-138 132-131"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-2-6",
					strokeDashoffset: -1.1,
					d: "M269 491c121-53 306 29 329 187"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-6-5",
					strokeDashoffset: -1.1,
					d: "M599 674c-94-115-345-160-462-51"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-1-3",
					strokeDashoffset: 13.2,
					d: "M556 467c109-66 311-22 392 75"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-9-7",
					strokeDasharray: "16.4 11.8",
					strokeDashoffset: -7.1,
					d: "M702 804c31-134 282-101 355-14"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-limb-4",
					strokeDashoffset: 1.2,
					d: "M1049 427c-93-51-273 59-273 173"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-4-8",
					strokeDashoffset: -14.8,
					d: "M772 600c-186-86-422-1-480 205"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-2-8",
					strokeDashoffset: 3.3,
					d: "M269 490c-75 95-81 192 27 316"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-3-7",
					strokeDashoffset: -6.4,
					d: "M949 541c138-8 155 153 110 247"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-1-2",
					strokeDashoffset: -14.5,
					d: "M552 466c-60-69-248-55-285 25"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-0-1",
					strokeDashoffset: .2,
					d: "M827 398c-83-55-223-21-270 69"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-2-limb",
					strokeDashoffset: 1.4,
					d: "M269 490c-25-55-135-65-155-23"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "rt-6-end",
					strokeDashoffset: 9.5,
					d: "M598 673c19-110 197-125 226-5"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "hb-dots",
			fill: "#ee6b06",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 827.1,
					cy: 398.4,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 557.1,
					cy: 466.7,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 268.5,
					cy: 491.2,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 949,
					cy: 541.9,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 775.7,
					cy: 599.9,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 136.9,
					cy: 621.8,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 596.6,
					cy: 674.6,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 1058.9,
					cy: 789.8,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 293,
					cy: 805,
					r: 8.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 703.2,
					cy: 804.1,
					r: 8.5
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "tk-truck",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "tk-chassis",
					children: [
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-rail",
							fill: "#fff",
							points: "194.4,259.7 200.3,251.6 283.8,302.3 292,299.9 291.7,317.6 228.5,279.6 200.3,268.6"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "tk-chassis-gap",
							width: 7,
							height: 16.6,
							x: 220,
							y: 277,
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-underbody",
							fill: "url(#tk-gu)",
							points: "224.6,277.9 292,316.4 292,328.9 284.8,331 246.2,308.2 246,304 226.8,293.4"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#768369",
							points: "228.7,296.4 247.4,303.7 247.6,306.5 238.9,300.5"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#9fadaf",
							rx: 3.1,
							ry: .8,
							transform: "rotate(34.5 -357.866 568.036)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#b3c2c2",
							rx: 2.4,
							ry: 1.1,
							transform: "rotate(25.4 -555.042 767.839)"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#2e3b3f",
							points: "266.6,305.4 268.6,305.3 268.2,312.9 265.8,311.7"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#f68922",
							d: "M193.9 277.5q-.3-6.2 8.7-13.3l46 27.1v2l-44.4-24.5q-4.5 3-5.5 9.8z"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#784a2b",
							points: "197.7,261.4 201,263.8 205.4,266.7 201.7,268 198.4,266.7"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "tk-wheel-rear",
					children: [
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#1b3742",
							points: "214.4,303.9 219.9,294.6 226.1,293.4 224.7,297.2 219.2,302.6 217.4,302.7"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#2c3739",
							rx: 12.3,
							ry: 17.2,
							transform: "rotate(-12.4 1426.51 -819.72)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#3e4849",
							rx: 11,
							ry: 17.7,
							transform: "rotate(-21 873.8 -413.158)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#e86b0e",
							rx: 7,
							ry: 12.5,
							transform: "rotate(-23.3 798.166 -355.728)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#fff",
							rx: 4.1,
							ry: 7.6,
							transform: "rotate(-23.1 805.238 -360.754)"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "tk-cargo",
					children: [
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-box-top",
							fill: "#ed6f09",
							points: "199.4,173.7 261.3,137 348,188.2 282.9,229.5"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-box-front",
							fill: "#384950",
							points: "199.1,173.6 285.9,225 285.9,303.4 199.1,251.8"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-box-side",
							fill: "#242f32",
							points: "285,225 347.8,188.1 347.6,268.4 285.3,303.2"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "tk-cab",
					children: [
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-cab-body",
							fill: "#fff",
							points: "291.5,236.9 358.9,197.8 406.6,229.6 410.6,259.1 415.6,279.2 429.6,299.1 431.1,326.7 363.5,363.6 346,365.6 291.5,334.5"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-cab-side",
							fill: "#dcdcdb",
							points: "292.9,238 341.3,268.4 344.1,299.4 350.3,318.6 354.8,327.5 362.9,339.9 364.8,341 366.7,364.6 345.3,365.9 292.6,335.5"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "tk-cab-lights",
							fill: "#f4f4f4",
							d: "m293.2 252.8.7-13.3 8.3 3.6 1.1 3.4-5.2 2.3-.9.5zm16.5.7-2.8-1.7 1.3-2 2 1.7zm8.7 6.5-2.3.2-3.7-1.9-.2-3.6 2.4-2.7 4.2 3.1 1 3.9zm22.8 19.4-5.5-4.8 3.3-.1v-5.2l-2.2-2.1-6.1.4 1.1-5.7 9.5 6.2-1 6.7zm-39.7 6-9.5-.9 2.1-12.5.4-3.2 1.3.3zm-9.1 18 1.8-5.9 3.9-1.5 4.2.2-1.2 3.4zm28.8 4.7-3.5-1.5 2.6-2.4zM299 321.8l-7.1-2 2.3-7.4 2.2 3.9 1.8-2.2 2.8 1.2-.1 6.2-2.5-4.1zm3.4 3.3-3.3-.2 2.7-1.1-1.2-3.5 3.5 3.2zm13.1 0-3.9-.2 3.6-2.2 1.1 1.2zm-5.6 1.8-6.9.1 3.4-1.6 4 1zm18.3 10.3-8.2-4.5.1-3.7h4.7l3.1-4.4zm28.2-6.1-5-.5v-10.5zm6.9 16-7.6-2.4-3.7 1.2v-1.8l-4.8 1.8-6.6-3.1-3.7-5.6-9.1-.1 2.2-11.9 9.5 5.4.8 2.9-3.9 1.6-.9 1.1 4.3-.2.5-2.1 5.4-1.2.3 3.4 2.8-1.5-.4 2.9 6.1 1.5 1.3 2.5 7.3.1zm-51.8-2.2-6-2.3-11.5-7.1-1.2-4 5.3 1.8 3.3-1.3 11.4 6zm51.8 18.7-5.8-.2-7.8-6.8-1.3 1.5-.6 5.9-4.1-.1-3.1-13.7 2.4 3.6 6.7-3.6 13.1 5zm-21.9-47.1 3.9 5.2-7.1 2.8 4.2 4.5 9-.1V318z"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-window",
							fill: "#89bbcf",
							points: "298.2,250 327.4,267.9 327.7,305 298.2,286.9"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#f6f4f4",
							points: "337.8,277 342.3,282.1 349.2,319.4 348.9,317.9"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#90bccc",
							points: "332.7,302.8 332.9,278.3 333.8,273.4 336.8,275.2 338,279.1 347.1,315.8 342.7,315.2 342,302.2 340.4,298.8"
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 1.2,
							height: 76.8,
							x: 329.1,
							y: 262.2,
							fill: "#d4d1d2"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#fff",
							points: "331,303.4 339.6,299.1 342.2,300.4 342.6,319.5 331,318.3"
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 2.3,
							height: 7.4,
							x: 336.2,
							y: 317.7,
							fill: "#acacac"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							cx: 342,
							cy: 320.1,
							fill: "#4d4b4b",
							rx: 2.2,
							ry: 2.4
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#5e7577",
							points: "416.1,258 416.9,258.8 416.1,266.5 419.2,277.2 418.1,279.2 415.4,281.2"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#fff",
							points: "411.5,258.9 413.4,258.5 415.7,279.7 413.7,279.3"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#fff",
							d: "M415 254.9q3.5-2.9 6-3 3.5 5.2.5 15.2l-3.6 2Z"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "tk-windshield",
					children: [
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#779db2",
							points: "340.2,270.1 406.3,231.8 409.1,247.4 342,280"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-ws-glass",
							fill: "#38a1af",
							points: "342.4,280.3 408.7,246.2 411.1,258.9 413.4,274.5 414.8,281 412.1,284.8 387.8,299.8 369.8,310.2 353.8,315.4 350.9,316"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#54a7ab",
							points: "385,259.5 406.5,244.1 412.6,276.1 403.6,270.6"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#0b77a3",
							points: "345.5,291.1 351.5,289 350.6,298.8 349.5,305.5 348.1,302.6"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#3b4c51",
							d: "M350.1 317.1c8.7-10 28.7-24.3 63.9-39.4l1 4.1c-11.4 11.6-29.9 23.1-46.9 30.8l-15.2 6.2z"
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 344.8,
							x2: 408,
							y1: 279.9,
							y2: 243.7,
							stroke: "#d3cbc4",
							strokeWidth: 1.3
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 376.5,
							x2: 385.6,
							y1: 261.8,
							y2: 301.4,
							stroke: "#cfcfcb",
							strokeWidth: 1.3
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "tk-hood-marks",
					fill: "none",
					stroke: "#dbdadb",
					strokeLinecap: "round",
					strokeWidth: 3.6,
					d: "m361.2 321.8 16.4-5.7m6.7-3.5 3.8-1.7m6.6-4-.1-.4m9.5-6 3.5-2.5m6.9-7.2.8-.8"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "tk-front",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "tk-fascia",
							fill: "#b0b0b0",
							d: "M363.8 341.1c25.2-4.7 50.8-18.4 66.2-38.9l1.4-2.1v26.5l-4.4 7.2-11.7 13.1-11.8 11.6-19.8 1.7-9.3 2.8-10.4 2.4z"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "tk-headlight-l",
							fill: "#fff",
							d: "m368 349.2 8.3-3.6q1.6 1 1.9 5.3v4q-.5 2.7-7 4-2.4-1-3.3-2.7z"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "tk-headlight-r",
							fill: "#fff",
							points: "423.6,319.9 429.1,313.9 429.5,323.9 425.5,329.1 423.4,329.7"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "none",
							stroke: "#32393d",
							strokeLinecap: "round",
							strokeWidth: 3.9,
							d: "m382.9 346 15.2-7m-14.5 15 15.8-7.5m6.2-11.3 12.2-10.2M406 343l12-9.2"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							fill: "#a29e99",
							points: "398.4,335.1 404.2,334.8 405.2,346.7 399.1,346.3"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "tk-bumper",
							fill: "#ec7207",
							d: "m349.2 357.5 1.6 3.2 13.6 6.9c21.8-1.5 46.2-15.2 63.7-33l2.2-3.5 1.4-3.7h2.2l.8 3.1-.9 9.7c-17 19-43.8 35-68.6 37.9q-9.9-2.6-16.1-9.7z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "none",
							stroke: "#4f505a",
							strokeLinejoin: "round",
							strokeWidth: 2,
							d: "m348.8 358.4 14.9 8.3c24.1-3.4 49.5-15.6 65.4-34.4"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "tk-wheel-front",
					children: [
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#8e8c81",
							rx: 11.4,
							ry: 18.1,
							transform: "rotate(-20.3 1144.321 -731.043)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#2a3234",
							rx: 10.3,
							ry: 18.5,
							transform: "rotate(-21.9 1082.99 -676.825)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#425254",
							rx: 10.6,
							ry: 18.6,
							transform: "rotate(-21 1124.431 -701)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#f27211",
							rx: 6.8,
							ry: 12.3,
							transform: "rotate(-22.2 1070.943 -650.834)"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							fill: "#fff",
							rx: 4,
							ry: 7.5,
							transform: "rotate(-22.3 1067.577 -647.125)"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "st-stacks",
			fillRule: "evenodd",
			mask: "url(#st-mask)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "st-base",
					width: 266,
					height: 304,
					x: 688,
					y: 74,
					fill: "#a87852"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c1",
					fill: "#8d6647",
					d: "m687.5 377.5 45.8-122 8.9 3.6 6.3-.4 1.7-4.8 4 3.3 17.7.7.5-15.1-.7-3 .7-9.4-53.3-36.5 52.9 31 .1-28.5-.1-12.1-55-33.1-28.5-77.7 266 1-6.8 132.7-54.1 32.2.3.9-.2 40 52.7-30.5 7.1 51.2-6.5-31.6.7-6v-9.3l-54.1 32.1.3 12.4-.2 35.5 23.2-21.1-2.8-3.1.7-3.3 4.7-.4 1.2 1.1-2 4.5 12.3-6.7 23.5 72.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c2",
					fill: "#cba382",
					d: "m893.7 239.4-66.6-39.2 1.1-3.1-55.9 33.4-54.1-31.5 1.3-4.6 53 31 54.9-32 .7-3.8-1-3.1 1.8-3.1-3.8-3.1-.4-1.6 8.5-6.8-3.1-16.3-2.8-3.8-55.4 32.4-46.3-27.5-8.6-5.7.7 6.3-29.2-83.8 266 1v163.1l-7-9 .4-12.3.1-9.2zM687.5 377.5l31.4-138 2.6 8.6 29.4 13.8 5.5-6.1 73.6 11.7-.2 13.2 55.7 32.6-.8 7.8 8.6 5.9zm259.9-83-.4-25.2-.8.2 2-6.7-.4-8.8-54 32-67.1-39.9-4.4-.1 4.5-4.8 66.9 39.5 52.8-30.7 7-1.2z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c3",
					fill: "#cec7c3",
					d: "m894.6 235.2-.7.2-53.5-32.6-12.2-6.1-5.8 3.3-1.9-.7-48.3 28.5-52.2-31-2.9 2.1 1.5-4.8 53.5 31.8 55.5-32.4 1.1-10-3.8-5.1 8.4-6.2-4.4-2.3-1-4 2.5-4.5-1.9-2.9 2-3.1-3-5.9 1-1.4 4.9-2.6-6.7 1.9-53.4 31.3-36.8-19.6-17.6-8.1-6.5-4.8 4.5 5.5v3.3l-28.4-81.5 266 1V207l-9.5-2.4zM687.5 377.5l1.8-122.8 63.1 5.8 4.1-4.1 34.1 5 26.6-5.7 12.1 12.6.6 12.8 55.1 32.2.9 1.1-1.4 6.7zm261.4-153-1.5-6 .8-2.8 6.3 21.8zM894 282.9l-68.2-40 1-1.7 67.2 39.9 33.4-20 1.2 1.2zm55.1-28.4-4.3-3 1.3-1.3 8.4 3.8zm-19.8 7.6-2.1-.3L939 255l1.8.5zm18.1 32.4-.3-25 2-5.1 5.3 36.1z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c4",
					fill: "#d5d4d4",
					d: "m899 228.4-5.5-.4-1.7 5.7-63.8-39.1v-9.1l.7-2.1-3.1-3.8 2.9-3.9.9 2 13.1 2.9-8.3-5.9-4.2-10.4.1-12.6-1.9-2.1 8.8-6-10.4 3.7-55.9 31.4-58.2-32.8 9-24.8-33-47.5 265.9.9-11 87.3 3.7 23.7-2.2 19.2zM867.1 83.9l-.4-2-29.3 29.1 3.9 4.9zm-147 39.5-.5-1.8h-12.1l6 3.3zm127 6.8-7.7.2 1.2 1.8h4.8zM824 146.4l-2.1-.8-10.6 5.7 2.3 1zm-34.5 13.4 7.9-5.4 3.2-4.5-14.7 9.2zm6.1 2.8 1-3.1-6.5 3.2-1.2 2.8zm73.6 26.6-2.2-2.8-9.5-6.7-.6 2.6zm-155.5 5.1 5.9-.5 1.1 3.2-5-1.9zM865.5 207l-5.2-4.7-2 1.3 3 2.3zm-147.4 3.1.8 4.2v25.2zm229.7 18.3-.5-9.6 5.2.2 1.9 1.5zM687.5 377.5l8.5-86.1-2.6-34.9 59.2 4.4 2.9-3.7 2-.5 33.2 4.9 26.5-5.9 5.9 11 2.8.5 4 13.8 18.1 10.8 35.8 20.9.9.1-.3 8 70 56.7zM809 258.1l-3.9.2v5.3l1.5.3zm144.5 42.7-6.3-6.2.4-29.3zm-175.7 26.7-.9-2.7-5.7-3.9 1.3 3.9z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c5",
					fill: "#a3a1a0",
					d: "m770.4 153-49.3-28.6-15.7-2.9 15.9-.3 40.5 23.7 8.8 4.4 67.5-39 2.9 5.2-5-.5-10.6 6.6zm2.8 19.3-5.5-1.3-45.8-27.1-4.9-10.3v-2.9l47.8 27.4 2.1.2 61.7-34.8 7.8-.3-17.6 9.8-20.7 13.1h-2.5l-21.5 12.6-5.8.6 3.9 2.4 12.2-5.9 29.5-17.6 1.6-.2 24.7-14.3h11l-15.7 6.9-33.8 17.8-16.9 11.4-12.1 5.5-13.1-6.6-33.4-19.4-4.6-3.4 2.3 6 47.4 27.6 18.1-9.4 24.2-14.9 12.8-6.4 13.3-7.8 2.7 4.8-3.5-.6zm-2.5 7-9.1-4.6-41.6-24.4.4-3.3 51.4 29.9 7.9-5.4 15.7-8.6 5.1-4.3 12-7.7.8 1.9 26.4-15.4.7 1.2-.4 2.7-6.6 4.4-6.8 2.3zm125.8 13.4-1.7.1-8.3-3-3.9-4-17.9-9.5-13.4-8.3-19.8-11.2-3.7-5.7 4.7 2.2 62.3 36.6 11.7-6.1 39.1-22.7.7 1.7-3.7 4.1zm-1.6 7.7-20.4-12.3-10-4.4-10.8-7-1.1-1.6-22.3-12.5-1-3.3 1.4-.9L864 179l6.4 3.3 25.4 14.5 48.5-27.2 10.1.9-9.4 2.5-43.5 24.9zm-207.2-35.7 5.8-1.1 27.2 3.5-9.1-.2zm208 43.2L869 191.5l-16.1-6.9 1.2-1.5-11.7-6.4-10.2-4-.8-1.5 4.3.5-6.9-7.5 27.2 16.5 1.2 1.6 38.4 21.8 49.8-27.6 9.1 1-8.2 2-15.9 9.2zm.6 8.1-21.9-12.9-5.8-2.3-10.3-7.3-27.4-13.8-1.4-3.2 1.9-.9 8.2 4.9 7.9 2.6 16.4 10.3 30.6 17.8 6.4.7 46.7-25.9 6.8.2-10.9 5.9-40.7 22.7zm-4.8 17.7-51.1-30.8-11.8-5.8-.2-9.2 3.2.6 45.3 26.2 16.5 8.2 3.5-.1-2-2.4-10.3-4.7-54.9-30.8h-1.4l-1.8-4.6 4.9 1.9 22.9 12.3 17.4 10.1 24.2 13 2.3 3.2 7.6-3.8 6-5.6 2.1.8 28.7-16.8.6 3.9-43.8 24.6-4.9 5.1-3.1-2.5-60.3-34.4-.2 2.3 19.9 11.6 2.4.2 19.4 12.3 17.9 9.8 2.3 2.4zm-173.6-35.1 1.6-4.8 1 1.7-1 1.6zM897 233.4l-1.2-1 1.1-2.6 43.6-25.4 3.1-2.3 3.2.3-3.3 4.4zm-179.5-25.8.6 1.9.8 30zm3 33.4.6 7.4 4.7-4.4.2 2.2zm70.1 19.9 21.5-12.5 2.6 1.6 4.5-.5zm-60.1-13.6 2.8 8.2-1.8 1.8zm12.5 11.2 2.6-2.6.8 2.2 1.1-1zm85.7 2.3h-7.3l-4.8-4.8 12.4 2.6zm9.7 85.2-35.7-20.4-19.8-12.4-60.4-9.9-1.8-3.1 5.8 1 70.1 10.5 32.5-41.9 1 11.3-4.9-2.5-27.8 36.2-7.6-.5 39.9 23.5 9 4.7 46.9-27.2-.5 5.5.5 1.5-2.7-2.2zm115.1-45.2-6.4-6.3.1-7.8 7.2 7.3zm-266 76.7v-85.4l8.7-.3 62.9 36.3h2.9l9.7-6.5.3 3 17.6 9.7 19.8 11.9 2.8 2.6 6.6 2.5 14 8.6 3.7 1.8 4-2.1 44-25.5 7.7-.7-10.1-1.7-40.3 23.4-5.1-1.4-2.1 2.3-2.2-.2-56.9-32.3-6.8-5 2.7-.3 32 17.4 9.2 6.2 22.2 12.3.1-3-62.2-35.1-.7-1.3 2.7-.9 41.7 23.4 8.4 5.8-.6-2.5 3.5 1.8 1.7 2.9 12.2 6.7 48-27.7 3.6 10.2 8.2-12 30.2-17.6 22.8 72.7zm163.7-16.7 34.4-20 1.4-1.7-4.8-.4-43.1 25.2-4.5.5-31-17.9-28.4-17.6-4.5-1.3-1.9 1.9 4.1 1.3 19.7 11.6 5.9 2.8 38.5 23.5z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c6",
					fill: "#8b8c8b",
					d: "m770.4 152.5-46.9-26.9-3.9-4.8 38 22.1 12.9 6.7 66.8-38.5-.1 3.2zm3 12.2-16.9-8-36.2-21.4-4-5.1 49.3 29 10.8-5.4 29.5-17.4h1.9l18.8-9.6.7-2.2 8.8-4.9.1 3.3-8.6 5.5-1.5 2.4-3.9-.3-48.9 28.1-3-.3-1.7 1.2 3.9 3 68.1-38.2 1.1 1.9zm-1.4 7.6-7.5-3.5-42.4-25.4.4-2.4 49 29 68.8-38.6-1.2 3.3zm1.2 6.7-2.6-.1-33.9-19.7-16.5-8.4.2-3.4 51 29.9 24-14.2 17.8-9.6 16.3-10.1 10.7-5.5-.7 2.7zm122.3 13.7-8.5-3.2-3.5-3.1-14-8.2-4.9-1.4-12-8.3-23.5-13.4-2.1-4.2 67.9 39.4 15.5-8.5 35.5-20.3v2.4l-17.4 10.8zm1.9 6.9-2.6.3-21.3-12.9-42.8-24.8-2.2-3.2 3.7 1.4 32.4 19.3 31.3 18 45.7-26.1 5.5-1.7-3.6 3.5zm-204.9-35.2 1-1 27.9 1.1-.7 1.7zM896.3 207l-42-22.9 1.2-.9-25.5-15.4-2.1.9.2-3.9 7.4 3.4 22.2 15.2 37.8 21.2 50.2-27.5.8 1.8-24.3 13.8zm.7 8.6-63.2-35 12.7 3 48.4 28.7 6.7-.2 45.8-25.6.1 2.8-46 25.5zm-11.4.1-59-33.1 2.4-.7 41.6 23.2 25.3 13.2 1.3 2.8zm8.4 12.1-.8-.8-38.6-21.3-3.2-2.6-22-13-2 .6-.1-3.6 38.2 21.5 5.1 4.6 24.8 11.2 2.3-3.1 9.8-5.3 4.1-3.9 2.2.8 28.6-16.8.9 3-34.8 19zm-206-29.3 31.6-4.7.6 2-4.6-.7zm201.9 33.4-17.3-9.1-32.2-19.4-11.5-6.2.7-.7-2.9-3.1.6-1.7 2.4.5 1.1 2.8 18.6 11 3.2 2.7 37.6 20.5 2.1 2.3zm8.1 0-2-.1 3.5-3.3 45-25.8-.8 3.2-24.1 13zm-208 22 27.5-46.3 1.4 7v25.2zM827.3 238l2.9 4.5-2.7 1-2.2-1.1zm-107.1 2.8.9 7.6 4.7-4.7.2 2.5zm76.9 16 14.8-8.4 2.8 1.6 4.5-.5zm-73-3.2 6.4-6.3 3.2 3-2.2 7zm18.9 4.8 4.5-1.3 2.3 1.1.4 2.4zm78.3 2.3-4.5-5h8.3l4.2 2.9zm17.1 84.8-23.1-13.4-32.1-19.4-57.7-9.6 71.1 9.1 33.1-42.7.2 10.7-4.8-1.9-27.5 35.6h-8.3v.8l16.1 8.7 25.1 15.6 7.8 3.5 4.1-1.6 43.2-25.1.3 1.8-3.1 2.2zm115.1-44.7-6.3-6.3-.2-7.5 7.4 6.6zm-109.4 66.7 3.7 9.3-160.3.7 8.4-85 61.7 35.7 3.8 1.2 10.2-7-.4 2.5 26.2 14.7 15.2 9.7 23 12.8 3.9-1.2 44-25.9 10.1-.3-9.2 2.4-38.9 22.4-9.8 4.8-30.1-16.9-30.8-19.5-4.3-.8-1.9 2.6 3.8 1.8 22.5 13.3 1.2-.6 40.7 25.3 48-27.4 18.1-.1zm87.2-62.5 14.8-9 8.5 8zm-.6 17.5-9.7-12.3 3.5-.8zm-87.8 31.6-7.2-2.8-62.8-35.9.5-1.9 1.9.7 24.3 14.9 17.9 9.1 8.1 5.8 11.9 5.4 3.1 2.9 3.9-1.5 44.7-25.7 1.6 3-8.3 3.1zm-8.7 1.9-23.6-12.5-17.3-10.3-18.8-10.5-4.7-4.2 8.7 3.7 16.2 9.8 1.2-1 13.5 8 4.1 3.9 19.3 10.2 4 .4zm66.2-31.7 1-2.2 8 12.9z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c7",
					fill: "#7d7c7c",
					d: "m837.3 111.6 3.5 4.3-3.8-2-12.8 7.6zm-93.4 25.3-19.8-11.4.4-.8 21.6 11.9zm52.1 1.2-.5-3 17.1-10.2 2.6 1.8zm-10.1 10.4 37.3-20.8 5.4-.5-3.2 3.5-2.6-.8-25.2 15.8-1.9-1.5-2 2.5zm-44.4-.9-21-12.8-1.8.9-2.1-4.9 28 16.5zm31.6 15.9-4.4-1.1 4.3-.3 12.5-6.1 28.9-18.1 1 1 11.1-6.6 2.4 1.1-46.4 26.3zm9.1 2.8 1.6-2.4 28.7-17.6 26.4-12-8.4 5.3-7.9 3.5zm-4.7-17.7 1-2.8 15.9-9.2-1.5 2.7zm-39 3.3-11-5.2-4.7-3.3-1-2.4zm35 26-2.1-.3 23.1-13.6 5.1-4.7 13.4-5.4 19.4-11.8 2.9.1zm-8-28.3-8-5.6 11.9 5.5-.4 1zm-37.9 3.2-6.7-2.2.5-2.4zm24.4 1-1.2-2.9 14.4 8.2 3.7 3.1zm2 8.7-14.1-7.7 2.7-1.4 17.4 11.2zm133.8 27.6-7.3-6.7-26.4-12.9-5.6-7.1 39.4 23.3 2.2 3zm47.1-20.1 10.7-8 .1 1.5-4.1 3zm-241.4-6.6 26-.4 1.7 1.5-.5 1.6zm77.7 8.4-11-6.4 4.3.8 6.6 3.8 4-.4zm78.5.9-9.2-5.6 5 1.4 7 4.3zm51.3 15.8 3.3-2.6 27.1-15.5 1.3-.1zm36.3-11.8-1.8-1 5.3-3.6 4.7-.1zm-73.7 5.8-11.6-9.2 19 10.2 14.2 9zm-20.1 2.9-11.8-6-2.2-4 14.8 9.1zm25 5.5-1.6 1-12.4-7.5.8-.9-2.4-2.2 27 15.3zm54.2.1 2.2-2.5 9-4 .4 1zm-49.8 10.7-1.8.2-27.4-16.7 9.2 2.2 30.1 19.2zm47.8.4 27.1-15.6-.5 1.8-5.9 4.3-16.7 9.1zm-40.4 10.5-10.9-6.7-11.9-5.4-14.5-9 .5-1.2 21.1 9.6zm-16.8-1.9-25.6-16.3 25.6 12.9 5.5 4.8zm32-10.7-6.4-4.6 6.6 2.1 6.3-.9zm-64.7-3.5 10.7 5.1 11.2 7.5 1.3-1.8 14.9 9 1.8 4.9zm103.2 6.9 1.1-2.6 7.6-3.9-.4 2.6zm-38.7 2.9-2.8-1.9 3.9.9 8.6-4.4zm9.4 4.6 14.8-8.5 1.5 1.1-12.2 7.1zm-186.2 27-30-30.3h29.3l.8 7zM893.4 227l-.2-2.9 3.2-.1 10.1-6.9 15-7.2zm-3.9-9-7.2-5 8.3 2.5 5.4 4zm-12.7-.8 4.3.3 7.6 5.4 3.1 3.1zm-155.4 26.2 2-1.8-2.7 5.9 4.9-3.2zm99.1 4.1-1.2-3.8 3-2 1.7 1.8zm-8.3 9.3-5.1-6.4 5.2-2.5 3.1-1.9zm-81.8-9.7 3.3 2.5 1.6-.9-4.1 8.8zm75.9 10.4-3.9-4 3.2-1.2 2.5 5.2zm-63 .9 2.2-2.2 4.3 2.1.4 2.3zm85.4 3.1-11.9-5.8h8.5l3.9 2.9zM818 285.9l.2-1.2L830 270v9.6h-.9l-.8-4.4zm-21.5 26.7 11-14.1 1 1-9 11.5zm-41-3.6-11-3.1-23-3 .3-1.8 47.9 7.2-.1 1.2zm-68 68.5 32-71.7 12.2 6.7-37.6 62.9zm126.1-45.6-24-15.6h2l13.9 7.1 10.4 7.1zm-44.1-12.4 2.7-.3 13.5 8.5zm108.8 11.9 10.4-5.7 2.3 7.1-6.2-2.6zm-64.8 13-8.3-3.8-18.7-12.4 8.2 3.7 1.5-.6 18.2 12.2zm-1.9-6.9-12.6-7.3 3.7-.1 20.2 12.5zm36.3 1.1 13.9-8-8.3 6zm17 1 4.5-3.8 4.8-.5-6.6 4.2zm-65.4 4.1-5.5-4.6 4.5 1.1 7 4.2 7.2 6.2zm66 3.2 4-3.5 9-4.2-4 3.5zm-61.1 7-13.9-11.1 4.3 2.5 1.6-.8 15.1 9 3.8 4.5zm75.4-6.6-12.5 5.7 17.9-10.2zm-37.2 6.4-2.9.4-12.4-7.6 1.2-.7zm-11 1.3-8.3-5.7 12.1 5.4z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c8",
					fill: "#4b4b4b",
					d: "m796 138 1-3.2 14.8-8.8 2.4 1.2zm1.6 7.3-1.9-2.2 10-6.3 5.2.5zm-.5 4.3 15.5-10.4 2.4.1-4.4 4.4zm-1.5 8.8 4.9-4.9 12.7-6.7-.9 2.2-8.8 5.6zm2.5 5.3h-2.3l4.3-4.1 11.5-7.2 2 2.3zm54.9 5.9 1.4-2.3 7.2 4.5 5.1 5.2zm-.2 6.3 1.7-1.5 13.2 7.6 2.6 4.3zm14.7 15.9-12.7-7.5.7-1.9 10 5.7 2.4 2.4zm-1.5 12.1-7.5-3.1-11.3-7.5 6.2 1.4 15.7 8.9zm1.5-4.6-7.7-4.9 1.5-.8 7.2 4.9zm-12.1 6.5-3.8-4.1 8 3.6 6.1 5.7zm6.1 9.8-9.1-5.4 2.2-2.7 12.7 10.5zm-173 162.9 28.2-69.3 3-3.1 12.3 7zm64.2-70.8 1.5-1.5 9.1 1.4 3.4 2.7zm55.8 21.1-7.7-4.9 2.6-1.1 3.1 1.5 7.5 6.3zm3.2 8.8-11.8-7.1 2.4-.3 12.2 7.4zm-16.7-4 1.2-1.5 11.2 6.6 1.1 3zm9.5 13-8.7-6.2 5.7 1.9 8.3 6.3zm5.5 8.9-9.6-5.5-.7.5-3.9-4.2.5-1.6 15.1 9.2 1.6 2.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-c9",
					fill: "#3b3939",
					d: "m799.7 141 6-3.9 2.5.3-.8 1.6zm2.8 6.4-.6-1.2 11.7-6.9-1.9 3.1zm51 21.9-.1-1.7 12.7 7.6-.6 1.3zm11 13.4-6.1-4.9 9.8 5.8zm1 7.6-10.1-5.9 2.2-.6 8.8 5.7zm-10.6 8.6-2.6-4.3 9.5 4.9 2.5 2.8zm.6 6.7-2.3-2.4 2 .2 7.1 5.1zM719 309v-1.9h2l9.7 5.5zm86.1 30.7-8-5.2.4-.9 10.9 6.1z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "st-glints",
					fill: "none",
					stroke: "#fff",
					strokeWidth: 1,
					d: "m829 120.7-7.8 4.2m16.7-2.2-9.3 6.5m9.1 1.3-3 2.2m-101.6-.2 3.8 2.3m-9.6.5 3.4 2.3m84.3-1.1-17 10.1m-57.4 2.2 8.6 5.2m61.5-2.5-4.5 3.2m-30.9-1.9-5.5 2.7m17-3-3.7 2.4m-25 4.5 7.1 3.5m-11.1 1.9 5.8 3.2m70.9-4.1 7.9 4.6m1.5 1 7.5 4.2m13.1-4.5 6.2 3.5m-7.9 1.7 7.7 5.1m75.9-3.9-14.3 8.3m-52.4-.2 8.9 4.9m44-5.3-3.8 2.3m-95.8.1 4.1 2.6m22.3-1.9 4.2 2m38-.8-3.3 1.1m23.5 1.5-17.1 9.3m-61.8-8 4.3 2.2m20.8-2.2 2.6 1.8m-11.2.3 14.9 9.2m11.3-8.9 5.3 3m35.1-2.6-2 1.3m-3.5 1.8-5.7 3.2m-59.1-2.3 4.7 3.5m24.8-1.1 4.7 2.7m38.1 1-.9 1.2m-24.5 4.4 1.8.9m-34.5 2.2 5.2 3.3m6.7-3.2 2.8 1.6m25.9-.2-3.1 1.5m-21.4-.6 3.7 2.1m24.8.7-4.7 3.3m-89.9 70-1.7 2.1m-1 1.4-4.4 5.9m-89 .3 1.2 4.1m24.9 3.2h3.5m1.8.7 5 .2m46.3-.5-2 2.5m-32.8 2 3.8.7m4.8-.9 2.8 1m-2.3 17.3 1.9 1.4m20.8-.6 10.1 5.5m69.7-3.6-23.9 14.9m-57.5-12 3.8 2.5m19.4-2.1 9.2 5.2m.8-5.2 2.1 1.2m-15.5 3.3 5.1 3.8m-22.9-.3 3.9 2.1m10.9 0 2.8 1m-12.5-.3 10.5 6.3"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "st-seams",
					fill: "none",
					children: [
						/* @__PURE__ */ _jsx("polyline", {
							id: "st-seam-1",
							stroke: "#755137",
							strokeWidth: .9,
							points: "719.3,163.8 772.7,195.7 827.7,165"
						}),
						/* @__PURE__ */ _jsx("polyline", {
							id: "st-seam-2",
							stroke: "#6f4c35",
							strokeWidth: .9,
							points: "720,211 773.3,242.2 826.1,210.5"
						}),
						/* @__PURE__ */ _jsx("polyline", {
							id: "st-seam-3",
							stroke: "#745036",
							strokeWidth: .9,
							points: "823,210 893.8,250.5 947,219.2"
						}),
						/* @__PURE__ */ _jsx("polyline", {
							id: "st-seam-4",
							stroke: "#755137",
							strokeWidth: 1.1,
							points: "826.5,257.9 894,297 946.6,266"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "st-details",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					id: "st-logo-1",
					cx: 781.6,
					cy: 113.3,
					fill: "#fff",
					rx: 7.6,
					ry: 4.3,
					transform: "rotate(-3.4 781.6 113.3)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "st-logo-2",
					cx: 882.6,
					cy: 153.2,
					fill: "#fff",
					rx: 8.1,
					ry: 3.8,
					transform: "rotate(-2 882.6 153.2)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "st-logo-3",
					cx: 772.9,
					cy: 284.1,
					fill: "#fff",
					rx: 8,
					ry: 4.1,
					transform: "rotate(-12.8 772.9 284.1)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "st-logo-4",
					cx: 826.5,
					cy: 307.8,
					fill: "#fff",
					rx: 7.5,
					ry: 4,
					transform: "rotate(-3.2 826.5 307.8)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "st-dot-yellow",
					cx: 917.5,
					cy: 157,
					fill: "#fde906",
					rx: 12.8,
					ry: 6.3,
					transform: "rotate(41.9 917.5 157)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "st-dot-red",
					cx: 856.5,
					cy: 153.1,
					fill: "#fb4908",
					rx: 9,
					ry: 5
				}),
				/* @__PURE__ */ _jsx("polygon", {
					id: "st-plus",
					fill: "#141919",
					points: "861.2,129.8 857.2,133.8 860.2,136.2 862.1,137 859,140.1 862.9,142.8 866.7,140.7 869.2,144.1 870.5,144.3 872.2,142.2 876.6,138.7 872.3,135.2 875.3,132.8 870.4,129.6 869,129.2 865.8,131.7"
				}),
				/* @__PURE__ */ _jsx("polygon", {
					id: "st-slot-1",
					fill: "#6b4932",
					points: "737.8,183.2 751.9,191.3 751.8,198.5 737.8,189.5"
				}),
				/* @__PURE__ */ _jsx("polygon", {
					id: "st-slot-2",
					fill: "#6e4a35",
					points: "737.3,229.4 751.5,238.3 751.5,244.5 736.8,235.5"
				}),
				/* @__PURE__ */ _jsx("polygon", {
					id: "st-slot-3",
					fill: "#6e4c33",
					points: "928.5,238.4 928.1,245.8 913.6,254 913.5,247.2"
				}),
				/* @__PURE__ */ _jsx("polygon", {
					id: "st-slot-4",
					fill: "#724c33",
					points: "928.4,284.7 928.3,291.5 913.6,300.2 913.6,293.5"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "st-speck-white",
					cx: 878.4,
					cy: 128.9,
					fill: "#fff",
					rx: 2.4,
					ry: 1.2,
					transform: "rotate(19.3 878.4 128.9)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "st-speck-peach",
					cx: 884.2,
					cy: 133.9,
					fill: "#e5c3aa",
					rx: 2.2,
					ry: 1.4,
					transform: "rotate(-9.6 884.2 133.9)"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgWorld);
export { ForwardRef as ReactComponent };
